export default __webpack_public_path__ + "static/media/modal-close-icon.1db8bf2f.svg";